export default {
  title: {
    regular: 'Tavalliset tuotteiden muokkaukset',
    meal: 'Luo ateriapaketti-tuote',
    upsell: 'Luo lisämyyntiryhmä',
  },
  description: {
    regular:
      'Valitse muokkaukset, jotka lisätään uuteen muokkausryhmään, jos ne ovat jo olemassa toisessa muokkausryhmässä. Voit myös luoda muokkausryhmän ensin ja lisätä uusia muokkauksia myöhemmin.',
    meal: 'Valitse tuotteet, jotka sisällytetään ateriapaketti-tuotteeseen. Jos tuotteita ei ole vielä olemassa, luo ne "Hallitse valikoita" -sivulla. Muista liittää ateriapakettituote oikeiden tuotteiden alle tuoterakentajan "Muokkaukset"-osiossa.',
    upsell:
      'Valitse tuotteet, jotka sisällytetään lisämyyntiryhmääsi. Jos tuotteita ei ole vielä olemassa, luo ne "Hallitse valikoita" -sivulla. Muista liittää lisämyyntituote oikeiden tuotteiden alle tuoterakentajan "Muokkaukset"-osiossa.',
  },
  fields: {
    name: {
      label: 'Nimi',
      placeholder: 'Anna muokkausryhmän nimi',
    },
    max_quantity: {
      label: 'Enimmäismäärä',
      placeholder: 'Muokkausten enimmäismäärä',
    },
    is_required: {
      label: 'Pakollinen',
    },
  },
  labels: {
    visible: 'Näkyvä',
    hidden: 'Piilotettu',
    multiply: 'Monistettava',
  },
  buttons: {
    save: 'Tallenna',
    close: 'Sulje',
  },
  toasts: {
    modifier_group_got_created: 'Muokkausryhmä luotiin',
    modifier_group_got_updated: 'Muokkausryhmä päivitettiin',
  },
};
